import { SVGProps } from 'react';

export const PadLockIcon = (props: SVGProps<SVGSVGElement>) => {
	const color = props.color ?? '#e1000f';
	return (
		<svg width='21' height='21' viewBox='0 0 20 27' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
			<path d='M15.02 11.6V6.75a5.011 5.011 0 0 0 -10.022 0v4.85' stroke={color} strokeWidth='1.69' />
			<path
				d='M5.676 20.934H3.797a2.5 2.5 0 0 0 -2.5 2.5v0a2.5 2.5 0 0 0 2.5 2.5h12.3a2.5 2.5 0 0 0 2.5 -2.5v0a2.5 2.5 0 0 0 -2.5 -2.5h-1.879'
				stroke={color}
				strokeWidth='1.69'
				strokeLinecap='round'
			/>
			<path
				d='M5.676 16.013H3.797a2.5 2.5 0 0 0 -2.5 2.5v0a2.5 2.5 0 0 0 2.5 2.5h1.879m8.747 -5H15.42a2.5 2.5 0 0 1 2.5 2.5v0a2.5 2.5 0 0 1 -2.5 2.5h-1.878'
				stroke={color}
				strokeWidth='1.69'
				strokeLinecap='round'
			/>
			<path
				d='M14.576 16.013H16.455a2.5 2.5 0 0 0 2.5 -2.5v0a2.5 2.5 0 0 0 -2.5 -2.5H3.797a2.5 2.5 0 0 0 -2.5 2.5v0a2.5 2.5 0 0 0 2.5 2.5h1.879'
				stroke={color}
				strokeWidth='1.69'
				strokeLinecap='round'
			/>
			<path
				d='M11.401 18.879a2.285 2.285 0 1 0 -2.261 0l-1.069 1.724a0.55 0.55 0 0 0 0.469 0.84h3.467a0.549 0.549 0 0 0 0.468 -0.84z'
				fill={color}
			/>
		</svg>
	);
};
